import React from "react";
import Icon from "@mdi/react";
import { mdiBank } from "@mdi/js";
import AddStripeBankAccount from "./AddStripeBankAccount";
import Modal from "components/Modal";

interface Props {
  accountId: string;
  open: boolean;
  closeHandler: (refresh: boolean) => void;
}

const ExternalBankAccountCard: React.FC<Props> = ({ accountId, open, closeHandler }) => {
  return (
    <Modal
      isOpen={open}
      closeModal={() => closeHandler(false)}
      isDisableCloseModal
      wrapperClass="!my-auto desktop:!min-h-fit text-sm"
      dialogClass="!bg-foreground !p-6 desktop:!p-10 !border !border-card !overflow-y-auto gap-2.5 mx-auto"
      closeClass="!hidden">
      <div
        id="external_bank_account"
        className="min-w-[300px] min-h-[30%] text-center flex flex-col justify-center items-center">
        <div className="alert w-full">
          <div className="flex flex-col items-center">
            {/* Icon */}
            <Icon path={mdiBank} size={3} className="text-green-500" />
          </div>

          <div className="flex flex-col items-center justify-center mt-4">
            <p className="text-green-600 text-lg p-4" id="unBlurred">
              Please first add a bank account to your wallet.
            </p>
            <AddStripeBankAccount
              accountId={accountId}
              isBroker={true}
              closeHandler={() => closeHandler(true)}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExternalBankAccountCard;
